import type { GroupedTechnologiesCategoryMap } from "app/pages/sales-intelligence/modules/technology/types/technologies";
import type { TechColumnName } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/columns";
import { ColumnType } from "app/pages/sales-intelligence/sub-modules/common/services/company-search-column-suggestions/types/columns";

import { createTechColumnName } from "../misc";

const getParentCategoryToSubCategories = (
    subCategories: readonly string[],
    subCategoriesOptions: GroupedTechnologiesCategoryMap["subCategories"],
): Record<string, readonly string[]> => {
    return subCategories.reduce<Record<string, string[]>>((acc, subCategory) => {
        const parentCategory = subCategoriesOptions.get(subCategory);

        if (parentCategory) {
            (acc[parentCategory] ??= []).push(subCategory);
        }

        return acc;
    }, {});
};

export const getSubCategoriesColumnNames = (
    subCategories: readonly string[],
    subCategoriesOptions: GroupedTechnologiesCategoryMap["subCategories"],
): TechColumnName[] => {
    const columnsNames: TechColumnName[] = [];

    if (subCategories.length === 1) {
        const [subCategory] = subCategories;

        if (subCategory) {
            columnsNames.push(createTechColumnName(ColumnType.TechSubCategory, subCategory));
        }
    }

    if (subCategories.length > 1) {
        const parentCategoryToSubCategories = getParentCategoryToSubCategories(subCategories, subCategoriesOptions);

        Object.entries(parentCategoryToSubCategories).forEach(([parentCategory, subCategories]) => {
            if (subCategories.length > 1) {
                columnsNames.push(createTechColumnName(ColumnType.TechCategory, parentCategory));
            } else {
                const [subCategory] = subCategories;

                columnsNames.push(createTechColumnName(ColumnType.TechSubCategory, subCategory));
            }
        });
    }

    return columnsNames;
};
